import React from 'react';

import s from './index.module.css';
import { ReactComponent as StarIcon } from '../../assets/icons/star.svg';

const Rating = ({ value }) => {
  const parsedValue = parseFloat(value, 10);
  const displayedValue = parsedValue.toString().replace('.', ',');

  return (
    parsedValue > 0 && (
      <div className={s.expertRating}>
        <div className={s.ratingValue}>
          <span>Рейтинг</span>
          <StarIcon className={s.starIcon} />
          <span>{displayedValue}</span>
        </div>
      </div>
    )
  );
};

export default Rating;
